import React from 'react'
import { useTranslation } from 'react-i18next'

import SearchContext from '~/constants/searchContext'

import BaseSearchPopper, { BaseSearchPopperProps } from './BaseSearchPopper'

export interface ClientSearchPopperProps
  extends Omit<
    BaseSearchPopperProps,
    'clientAdvancedSearch' | 'placeholder' | 'searchContext' | 'text'
  > {}

const ClientSearchPopper = (props: ClientSearchPopperProps) => {
  const { t } = useTranslation(['Common', 'Search'])

  return (
    <BaseSearchPopper
      clientAdvancedSearch
      placeholder={t('Search:CLIENTS')}
      searchContext={SearchContext.CLIENT_PATIENTS}
      text={t('Common:ADD_CLIENT')}
      {...props}
    />
  )
}

export default ClientSearchPopper
